import { InlineAlertType, InlineAlertWidget } from '@tableau/widgets';
import * as React from 'react';

import { ReactActionDialogBodyProps } from './ReactActionDialog';

export type ActionDialogBodyWithInlineErrorMessageProps = {
  dialogMessage: string;
};

export type ActionDialogBodyWithInlineErrorMessageState = {
  errorMessage?: string;
};

export function ActionDialogBodyWithInlineErrorMessage(props: ReactActionDialogBodyProps<ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState>): JSX.Element {
  return (
    <div>
      {props.dialogMessage}
      {!!props.dialogState.errorMessage &&
        <InlineAlertWidget testId={'action-dialog-body-error'} type={InlineAlertType.Error}>
          {props.dialogState.errorMessage}
        </InlineAlertWidget>
      }
    </div>
  );
}
